import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import { webpSimpleTransformer } from "Helpers/ImageManager";
import { BackgroundImage } from "ComponentsUI/BackgroundImage";

const useStyles = createUseStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.colors.paleGrey,
		padding: "200px 0 60px",
		position: "relative",
		zIndex: 0,
	},
	container: {
		paddingLeft: "40px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	containerHeader: {
		width: "100%",
	},
	image: {
		backgroundColor: theme.palette.colors.slateBlue,
	},
	marginBottom40: {
		marginBottom: "40px",
	},
	mainBreadCrumbs: {},
	actionBreadCrumbs: {},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		container: {
			paddingLeft: "35px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			padding: "180px 0 40px",
		},
		container: {
			paddingLeft: "25px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			padding: "80px 0 40px",
		},
		container: {
			paddingLeft: "8.33%",
		},
		mainBreadCrumbs: {
			minHeight: "79px",
		},
		actionBreadCrumbs: {
			minHeight: "54px",
		},
	},
}));

const PageTitle404 = (props) => {
	let image = null;
	let classes = useStyles();
	if (props.background)
		image = (
			<BackgroundImage
				webpTransformer={webpSimpleTransformer}
				windowSizes={props.windowSizes}
				background={props.background}
				shiftY={25}
			/>
		);
	return (
		<div
			className={classNames(classes.root, {
				[classes.image]: props.background,
			})}
		>
			<Container>
				<div className={classes.containerHeader}>{props.upper}</div>
			</Container>
			{props.middle}
			{props.bottom}
			{image}
		</div>
	);
};

export default PageTitle404;
